module.exports = __webpack_public_path__ + "static/media/dailyActivity.ea6baa9e.svg";